import ModalVideo from './ModalVideo';
import { escapeAttr } from '../utility';

class LoadNextPost {
  constructor(el) {
    const _this = this;
    this.dom = {el: el} // data-js="viewmore-posts"
    this.dom.container = this.dom.el.querySelector('[data-js="viewmore-container"]')
    this.dom.form = this.dom.el.querySelector('[data-js="viewmore-form"]')
    this.dom.trigger = this.dom.el.querySelector('[data-js="viewmore-trigger"]')

    if (this.dom.form) {
      this.data = {}
      this.data.action = this.dom.form.querySelector('input[type="hidden"][name="action"]')
      this.data.post_type = this.dom.form.querySelector('input[type="hidden"][name="post_type"]')
      this.data.next_page = this.dom.form.querySelector('input[type="hidden"][name="next_page"]')
      this.data.posts_per_page = this.dom.form.querySelector('input[type="hidden"][name="posts_per_page"]')
      this.data.contents = this.dom.form.querySelector('input[type="hidden"][name="contents"]')
  
      this.init();
    }
  }

  init() {
    const data = this.data;

    const action_uri = this.dom.form.getAttribute('action');
    
    const domTrigger = this.dom.trigger;
    const domContainer = this.dom.container;
  
    if (domTrigger) {
      domTrigger.addEventListener('click', () => {
        loadMorePosts();
        data.next_page.value = parseInt(data.next_page.value) + 1;
      });
    }
  
    const loadMorePosts = async () => {
      domTrigger.disabled = true; // 連打防止
  
      // 必要に応じてnonceなどを追加  
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (key === 'next_page') {
          formData.append(key, parseInt(data.next_page.value) + 1);
        } else {
          formData.append(key, value.defaultValue);
        }
      });
      
      try {
        const response = await fetch(action_uri, { // WordPress が定義する ajaxurl を利用
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
  
        if (data.success && data.posts) {
          const createArticle = (post) => {
            const article = document.createElement('li');
            article.classList.add('mve-contents-unit');

            // デバッグ用ログ出力（開発時のみ）
            // console.log('Post data:', post);
            // console.log('Position:', post.position);
            // console.log('Copy:', post.copy);
            // console.log('Municipalities:', post.municipalities);

            // データが存在しない場合のデフォルト値を設定
            const lat = post.position && post.position.lat ? post.position.lat : '';
            const lng = post.position && post.position.lng ? post.position.lng : '';
            const copy = post.copy || '';
            const municipalities = post.municipalities || '';
            const eyecatch = post.eyecatch || '';

            article.innerHTML = `
              <button class="mve-contents-unit__inner" data-js="modal-video" data-id="${post.movie}" data-lat="${lat}" data-lng="${lng}" data-copy="${escapeAttr(copy)}" data-municipalities="${escapeAttr(municipalities)}" data-eyecatch="${eyecatch}">
                <figure class="mve-contents-unit__thumbnail">
                  <span class="c-clip"><img src="http://img.youtube.com/vi/${post.movie}/sddefault.jpg" width="640" height="480" alt="" loading="lazy"></span>
                </figure>
                <span class="mve-contents-unit__icon">
                  <svg viewBox="0 0 32 32"><use xlink:href="#play"></use></svg>
                </span>
              </button>
            `;
            return article;
          }
          
          const fragment = document.createDocumentFragment();
          const newElements = [];
          data.posts.forEach(post => {
            const article = createArticle(post);
            fragment.appendChild(article);
            newElements.push(article);
          });
          domContainer.appendChild(fragment);
          
          // 新しく追加された要素にModalVideoを適用
          newElements.forEach(article => {
            const modalVideoElement = article.querySelector('[data-js="modal-video"]');
            if (modalVideoElement) {
              new ModalVideo(modalVideoElement);
            }
          });
          
          if (!data.has_more) {
            domTrigger.style.display = 'none';
          }
        } else {
          console.error('記事の読み込みに失敗しました:', data.error);
          // エラー処理
        }
      } catch (error) {
        console.error('記事の読み込みエラー:', error);
        // エラー処理
      } finally {
        domTrigger.disabled = false;
      }
    }
  }

  htmlToNode(htmlStr) {
    if (!htmlStr || typeof htmlStr !== 'string') return;
    let tmpElmt = document.createElement('div'), i = 0, len = 0, nodes = [];
    // 高速処理するが対応ブラウザを考えinnerHTMLを使用
    tmpElmt.innerHTML = htmlStr; // tmpElmt.insertAdjacentHTML('beforeend', htmlStr);
    return tmpElmt.childNodes;
  }
}

export default LoadNextPost